module.exports = __webpack_public_path__ + "img/img3.67c6b086.png";